import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { ObjectivePlayGround } = await import('./index');
    return {
        Component: ObjectivePlayGround,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
